import type { LoginActivityItem } from "hooks/useLoginActivity/useLoginActivity.types";

export const createIndexArray = (count: number): number[] => {
  const result: number[] = [];
  for (let i = 0; i < count; i += 1) {
    result.push(i);
  }
  return result;
};

export const getLoginStatusBadgeVariant = (status: LoginActivityItem["status"]) => {
  if (status === "SUCCESS") return "success" as const;
  if (status === "PENDING_MFA") return "warning" as const;
  if (status === "LOGOUT") return "secondary" as const;
  return "destructive" as const;
};
